module.exports = __webpack_public_path__ + "static/index/img/settings.99dac742.png";